import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIIcon from 'UIComponents/icon/UIIcon';
import { GYPSUM, OLAF, KOALA } from 'HubStyleTokens/colors';
import { API_FULL_ACCESS } from 'self-service-api/constants/FreeUserAccessValues';
import FeaturesTableTitle from './FeaturesTableTitle';
const TableRow = styled.tr.withConfig({
  displayName: "FeaturesTableRow__TableRow",
  componentId: "ce7ty6-0"
})([":nth-child(even){background-color:", ";}:nth-child(odd){background-color:", ";}:hover{background-color:", " !important;}"], OLAF, GYPSUM, KOALA);
const LeftHeaderCell = styled.th.withConfig({
  displayName: "FeaturesTableRow__LeftHeaderCell",
  componentId: "ce7ty6-1"
})(["height:40px;& > p{margin-bottom:0;font-weight:500;}text-align:center;width:18.75%;min-width:175px;:nth-child(2){width:25%;text-align:left;}"]);
const UserIconCell = styled.th.withConfig({
  displayName: "FeaturesTableRow__UserIconCell",
  componentId: "ce7ty6-2"
})(["height:40px;width:2%;min-width:30px;& > p{margin-left:10px;margin-bottom:0;}"]);

const UserIcon = (freeUserAccessLevel, showTooltip) => {
  if (freeUserAccessLevel === API_FULL_ACCESS) {
    return null;
  }

  return /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(UITooltip, {
      disabled: !showTooltip,
      placement: "right",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `pricing-pages.freeUser.${freeUserAccessLevel}`
      }),
      children: /*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        name: "contacts"
      })
    })
  });
};

const FeaturesTableRow = ({
  feature,
  children,
  showTooltip = true,
  highestTier
}) => {
  return /*#__PURE__*/_jsxs(TableRow, {
    children: [/*#__PURE__*/_jsx(UserIconCell, {
      children: UserIcon(feature.freeUserAccessLevel, showTooltip)
    }), /*#__PURE__*/_jsx(LeftHeaderCell, {
      children: /*#__PURE__*/_jsx(FeaturesTableTitle, {
        feature: feature,
        showTooltip: showTooltip,
        highestTier: highestTier
      })
    }), children]
  }, feature.featureId);
};

export default FeaturesTableRow;